import { computed } from 'vue'
import { useStore } from 'vuex'

export function usePermissions() {
  const store = useStore()
  
  const userPermissions = computed(() => store.getters['auth/userPermissions'])
  
  const hasPermission = (permissionName) => {
    return store.getters['auth/hasPermission'](permissionName)
  }
  
  const hasAnyPermission = (permissionNames) => {
    return store.getters['auth/hasAnyPermission'](permissionNames)
  }
  
  const hasAllPermissions = (permissionNames) => {
    return permissionNames.every(name => hasPermission(name))
  }
  
  return {
    userPermissions,
    hasPermission,
    hasAnyPermission,
    hasAllPermissions
  }
} 